export const ORGANIZATION_TYPE = {
    OWN_GROUP: 'OWN_GROUP',
    CORPORATE_CUSTOMER: 'CORPORATE_CUSTOMER',
    CONTRACT_CLIENT: 'CONTRACT_CLIENT',
    AMC_CLIENT: 'AMC_CLIENT',
};
export const ORGANIZATION_TYPE_LABELS = {
    OWN_GROUP: 'Own group company',
    CORPORATE_CUSTOMER: 'Corporate customer',
    CONTRACT_CLIENT: 'Contract client',
    AMC_CLIENT: 'AMC / support client',
};
//# sourceMappingURL=organization-type.js.map